import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import Link from 'flarum/common/components/Link';
export default class MundialTeamVotersModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "team", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.team = this.attrs.team;
  }
  className() {
    return 'MundialTeamVotersModal Modal--small';
  }
  title() {
    return app.translator.trans('nagusi-match-ratings.forum.mundial.voters_modal_title', {
      team: this.team.name()
    });
  }
  content() {
    const voters = this.team.voters() || [];
    if (voters.length === 0) {
      return m("div", {
        style: "text-align: center; padding: 25px;"
      }, m("p", null, app.translator.trans('nagusi-match-ratings.forum.mundial.no_voters')));
    }
    return m("div", {
      style: "padding: 20px;"
    }, m("div", {
      style: "display: flex; flex-direction: column; gap: 12px; max-height: 350px; overflow-y: auto;"
    }, voters.map(voter => {
      const userModel = app.store.getById('users', String(voter.id)) || app.store.createRecord('users', {
        id: String(voter.id),
        attributes: {
          username: voter.username,
          displayName: voter.displayName,
          avatarUrl: voter.avatarUrl
        }
      });
      const userUrl = app.route('user', {
        username: userModel.slug()
      });
      return m("div", {
        style: "display: flex; align-items: center; gap: 12px; padding: 8px 12px; background: #fafafa; border-radius: 8px; border: 1px solid #eee;"
      }, m(Link, {
        href: userUrl,
        onclick: () => this.hide()
      }, avatar(userModel, {
        className: 'Player-Avatar-Tiny'
      })), m(Link, {
        href: userUrl,
        onclick: () => this.hide(),
        style: "font-weight: bold; text-decoration: none; color: #333; font-size: 1.1em;"
      }, username(userModel)));
    })));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/mundial/MundialTeamVotersModal', MundialTeamVotersModal);